import { b } from './chunk-JM7L7N4B.mjs';
import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';
import { useConnect } from 'wagmi';
import a$1 from 'react';

var s=create(a);function l(){let{appName:t}=b(),{connectors:o}=useConnect();return a$1.useMemo(()=>t??o.find(({options:p})=>!!p.appName)?.options.appName??"Current app",[o])}

export { s as a, l as b };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-YLQL22QZ.mjs.map